import { v4 as uuidv4 } from "uuid";

export default function util() {
  return [
    {
      name: "Ram Siya Ram (Adipurush)",
      artist: "	Sachet Tandon, Parampara Tandon",
      cover: ["https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiW73gORuhpUwA26kXuzpxQi2b1SFEsr4x8ufuKLZAeqa_F2V3UDs-k6yLQl9SCgF2Pn6kkf-BFw6kNGUbWIcmuC4kS7e5KFKjBMWWyYs1vbxlMpEPFBDPauvIABstWqFtwtm0BLKhgEx6f7LD4c9OOA7f2lwIzMoI7oeq6to0xgw11BfC-bsw38BJ9oA/s0/1500x1500-Jai-Shri-Ram-clean-1.jpg", "https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEiW73gORuhpUwA26kXuzpxQi2b1SFEsr4x8ufuKLZAeqa_F2V3UDs-k6yLQl9SCgF2Pn6kkf-BFw6kNGUbWIcmuC4kS7e5KFKjBMWWyYs1vbxlMpEPFBDPauvIABstWqFtwtm0BLKhgEx6f7LD4c9OOA7f2lwIzMoI7oeq6to0xgw11BfC-bsw38BJ9oA/s0/1500x1500-Jai-Shri-Ram-clean-1.jpg"],
      audio: "https://www.pagalworld.com.se/files/download/id/66697",
      id: uuidv4(),
      active: false,
    },

    {
      name: "Heeriye",
      artist: "	Jasleen Royal, Arijit Singh",
      cover:
        ["https://lyricalsansar.com/wp-content/uploads/2023/08/Heeriye-Lyrics.jpg?x15301", "https://lyricalsansar.com/wp-content/uploads/2023/08/Heeriye-Lyrics.jpg?x15301"],
      audio: "https://www.pagalworld.com.se/files/download/id/67444",
      id: uuidv4(),
      active: false,
    },
  ];
}
